import { useUserUiPreferences } from "./useUserUiPreferences.js";

export default function useConsolidationDisplayPreferences() {
  const { preferences, updatePreferences } = useUserUiPreferences();
  const set = (key, value) => {
    // The shared provider reports errors and restores the confirmed preference.
    void updatePreferences({ [key]: value }, { immediate: true }).catch(() => {});
  };
  return {
    hideArrival: preferences.consolidation_hide_arrival,
    showPlanned: preferences.consolidation_show_planned,
    hideTiming: preferences.consolidation_hide_timing,
    showBilled: preferences.consolidation_show_billed,
    showHoursSummary: preferences.consolidation_show_hours_summary,
    setHideArrival: value => set("consolidation_hide_arrival", value),
    setShowPlanned: value => set("consolidation_show_planned", value),
    setHideTiming: value => set("consolidation_hide_timing", value),
    setShowBilled: value => set("consolidation_show_billed", value),
    setShowHoursSummary: value => set("consolidation_show_hours_summary", value),
  };
}
